import { useSelector } from "react-redux";
import { useTranslation, Trans } from "react-i18next";
import { useBreadcrumb } from "hooks/useBreadcrumb";
import { stringFormatingToPascal } from "js/formatting";

import ContactUsCard from "components/General/ContactUsCard";
import CallToActionCardWithIconOnTop from "components/General/CallToActionCardWithIconOnTop";

export default function Payee() {
  useBreadcrumb([]);
  const { t } = useTranslation();
  const { user } = useSelector((s) => s.user);

  return (
    <>
      <div className="container ui-component-spacing">
        <h1>
          {t("CustomerDashboard-welcomeMessage", {
            name: stringFormatingToPascal(user.firstName),
          })}
        </h1>
        <hr />
      </div>

      <div className="container ui-component-spacing">
        <h3 className="text-center">
          <Trans
            i18nKey="AlertsCorrespondence-correspondence-text-1"
            components={{ break: <br /> }}
          />
        </h3>
      </div>

      <div className="container ui-component-spacing">
        <div className="grid gap-4 grid-cols-1 auto-rows-min content-start md:grid-cols-3 md:gap-6 md:grid-row-auto">
          <CallToActionCardWithIconOnTop
            action=""
            icon="#ui-icon-bolt"
            title={t("CustomerHelp-contactAction-1-title")}
            desc={t("CustomerHelp-contactAction-1-description")}
            subAction="phone"
            phoneNumber={t("CustomerHelp-contactAction-phoneNumber-1")}
            phoneNumberForAnnuity={t(
              "CustomerHelp-contactAction-phoneNumber-2"
            )}
          />
          <CallToActionCardWithIconOnTop
            action=""
            icon="#ui-icon-document"
            title={t("CustomerHelp-contactAction-3-title")}
            desc={t("CustomerHelp-contactAction-3-description")}
            subAction="phone"
            phoneNumber={t("CustomerHelp-contactAction-phoneNumber-1")}
            phoneNumberForAnnuity={t(
              "CustomerHelp-contactAction-phoneNumber-2"
            )}
          />
          <CallToActionCardWithIconOnTop
            action=""
            icon="#ui-icon-message"
            title={t("CustomerHelp-contactAction-4-title")}
            desc={t("CustomerHelp-contactAction-4-description")}
          />
        </div>
      </div>

      <ContactUsCard />
    </>
  );
}
